module.exports = __webpack_public_path__ + "static/media/linkedin.ebf40b1e.svg";